import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { createIcon } from "@chakra-ui/icon";
import { Skeleton, Box } from "@chakra-ui/react";
import { useMemo, useState, useEffect } from "react";
const Al = createIcon({
  displayName: "Al",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { x: "1", y: "1", width: "48", height: "32", fill: "#FF1A26", stroke: "#F3F6F9" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.5916 8.99019C24.7909 9.27217 25.2091 9.27217 25.4084 8.99019L27.2942 6.32108C27.4148 6.15039 27.6288 6.07272 27.8308 6.12632L29.7207 6.62787C30.1417 6.73961 30.2285 7.29886 29.8611 7.53287L27.0341 9.33339C26.8218 9.46859 26.7431 9.7405 26.8504 9.96818L27.2477 10.8116C27.3778 11.088 27.7232 11.184 27.9773 11.0146L34.0697 6.95335C34.5512 6.63237 35.1024 7.24946 34.7292 7.69179L32.3485 10.5139C32.0743 10.839 32.3054 11.3363 32.7307 11.3363H34.0542C34.5413 11.3363 34.7408 11.9619 34.3437 12.2439L32.1083 13.8316C31.866 14.0037 31.8264 14.3478 32.0232 14.5704L34.0285 16.8386C34.3394 17.1902 34.0382 17.7378 33.5748 17.6635L30.3967 17.1541C29.9548 17.0832 29.6496 17.5841 29.9151 17.9444L32.7065 21.7322C33.022 22.1602 32.5398 22.7195 32.07 22.4706L27.6026 20.1043C27.3718 19.982 27.0857 20.058 26.946 20.2788L26.8575 20.4187C26.7415 20.6022 26.7571 20.8396 26.8961 21.0063L28.7296 23.2043C28.9528 23.4718 28.8408 23.8798 28.5124 23.996L26.8806 24.573C26.7424 24.6219 26.6326 24.729 26.5803 24.8659L25.4671 27.7782C25.3032 28.2068 24.6968 28.2068 24.533 27.7782L23.4197 24.8659C23.3674 24.729 23.2576 24.6219 23.1194 24.573L21.4876 23.996C21.1592 23.8798 21.0472 23.4718 21.2704 23.2043L23.1039 21.0063C23.2429 20.8396 23.2585 20.6022 23.1425 20.4187L23.054 20.2788C22.9143 20.058 22.6282 19.982 22.3974 20.1043L17.93 22.4706C17.4602 22.7195 16.978 22.1602 17.2935 21.7322L20.0849 17.9444C20.3504 17.5841 20.0452 17.0832 19.6033 17.1541L16.4252 17.6635C15.9618 17.7378 15.6606 17.1902 15.9715 16.8386L17.9768 14.5704C18.1736 14.3478 18.134 14.0037 17.8917 13.8316L15.6563 12.2439C15.2592 11.9619 15.4587 11.3363 15.9458 11.3363H17.2693C17.6946 11.3363 17.9257 10.839 17.6515 10.5139L15.2708 7.69179C14.8976 7.24946 15.4488 6.63237 15.9303 6.95335L22.0227 11.0146C22.2768 11.184 22.6222 11.088 22.7523 10.8116L23.1496 9.96818C23.2569 9.7405 23.1782 9.46859 22.9659 9.33339L20.1389 7.53287C19.7715 7.29886 19.8583 6.73961 20.2793 6.62787L22.1692 6.12632C22.3712 6.07272 22.5852 6.15039 22.7058 6.32108L24.5916 8.99019Z",
        fill: "#0B0F14"
      }
    )
  ] })
});
const Anac = createIcon({
  displayName: "Anac",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { x: "1", y: "1", width: "48", height: "32", fill: "#1659BF" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M16.0981 24.7496C16.1048 24.7412 16.1084 24.7309 16.1084 24.7202C16.1084 24.7096 16.1048 24.6992 16.0981 24.6908C15.7414 24.1157 15.5161 23.4721 15.4377 22.8041C15.3592 22.136 15.4296 21.4593 15.6438 20.8203C16.4101 17.9762 19.021 15.084 22.2121 13.2022C24.9531 11.715 27.7951 10.4129 30.7182 9.30497C28.7798 7.73021 26.3373 6.86942 23.8159 6.87253C22.3958 6.87183 20.9895 7.14441 19.6773 7.67471C18.3651 8.205 17.1727 8.98261 16.1683 9.96312C15.1638 10.9436 14.367 12.1078 13.8234 13.3892C13.2798 14.6705 13 16.0439 13 17.4309C12.9959 20.1601 14.0773 22.7842 16.016 24.7496C16.0241 24.7571 16.0349 24.7613 16.0461 24.7613C16.0573 24.7613 16.0681 24.7571 16.0762 24.7496",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M32.6778 11.3578C29.6399 12.5039 26.6863 13.8524 23.8378 15.3941C20.8601 17.0995 18.4189 19.7671 17.7183 22.3974C17.1052 24.6801 17.9372 26.4122 19.7216 27.2088C21.0276 27.7328 22.426 28.0016 23.8378 28C25.2579 28 26.6641 27.7267 27.9761 27.1958C29.288 26.6648 30.48 25.8866 31.4839 24.9056C32.4878 23.9246 33.284 22.76 33.8269 21.4784C34.3699 20.1968 34.649 18.8233 34.6483 17.4363C34.6523 15.2613 33.9637 13.1389 32.6778 11.3632",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M38.9615 11.8978L37.095 8.69018L37.9434 8.31596C38.0768 8.27551 38.1946 8.19675 38.2815 8.08995C38.3684 7.98314 38.4203 7.85325 38.4306 7.7172C38.4229 7.63711 38.3861 7.56236 38.3268 7.50647C38.2676 7.45058 38.1898 7.41723 38.1076 7.41248C37.8919 7.3895 37.6737 7.41137 37.4672 7.47663C37.3851 7.47663 36.8268 7.7279 36.2137 7.97916L32.1578 6.01183C32.1173 5.99606 32.0723 5.99606 32.0319 6.01183L31.8622 6.04925C31.8549 6.04925 31.848 6.05206 31.8428 6.05707C31.8377 6.06209 31.8348 6.06889 31.8348 6.07597C31.8348 6.08306 31.8377 6.08986 31.8428 6.09488C31.848 6.09989 31.8549 6.10271 31.8622 6.10271L34.7413 8.07004L35.1464 8.42822L34.4348 8.71156C34.2933 8.76982 34.1561 8.8377 34.0243 8.91471L33.8382 8.38011C33.8328 8.36449 33.8241 8.35014 33.8127 8.33801C33.8013 8.32587 33.7874 8.31621 33.7719 8.30966C33.7564 8.30311 33.7397 8.29981 33.7228 8.29997C33.706 8.30013 33.6893 8.30376 33.674 8.31061L33.4277 8.41219C33.4085 8.41971 33.3918 8.43212 33.3793 8.44811C33.3668 8.4641 33.3589 8.48308 33.3565 8.50307L33.2361 9.13925L31.8731 8.60464C31.7938 8.57503 31.7061 8.57503 31.6268 8.60464L31.3805 8.69018C31.3746 8.69267 31.3696 8.69679 31.3661 8.70201C31.3626 8.70723 31.3608 8.71334 31.3608 8.71958C31.3608 8.72582 31.3626 8.73193 31.3661 8.73716C31.3696 8.74238 31.3746 8.74649 31.3805 8.74898L32.9679 9.73265L33.0773 9.90373L33.8929 11.1333C33.8981 11.139 33.9044 11.1436 33.9114 11.1467C33.9185 11.1498 33.9262 11.1514 33.934 11.1514C33.9417 11.1514 33.9494 11.1498 33.9565 11.1467C33.9636 11.1436 33.9699 11.139 33.975 11.1333L34.1556 10.9515C34.1838 10.9241 34.2037 10.8897 34.2134 10.852C34.223 10.8144 34.222 10.7748 34.2104 10.7377L33.9531 9.83422C34.3284 9.80523 34.6973 9.72236 35.0478 9.58831C35.1354 9.55623 35.5952 9.36912 36.0605 9.15528L36.4655 9.51881L38.8028 12.1277C38.8072 12.1343 38.8134 12.1397 38.8205 12.1435C38.8277 12.1472 38.8357 12.1492 38.8438 12.1492C38.8519 12.1492 38.86 12.1472 38.8671 12.1435C38.8743 12.1397 38.8804 12.1343 38.8849 12.1277L38.9834 12.0047C38.9942 11.9889 39 11.9703 39 11.9512C39 11.9322 38.9942 11.9136 38.9834 11.8978",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Anac$1 = Anac;
const At = createIcon({
  displayName: "At",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "red", x: "1.5", y: "1", width: "48", height: "11", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("rect", { id: "red_2", x: "1.5", y: "22", width: "48", height: "11", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("rect", { id: "white", x: "1.5", y: "12", width: "48", height: "10", fill: "white" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Au = createIcon({
  displayName: "Au",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "blue dark", x: "1.5", y: "1", width: "48", height: "32", fill: "#0070B8" }),
    /* @__PURE__ */ jsxs("g", { id: "UK corner", children: [
      /* @__PURE__ */ jsx("path", { id: "blue dark_2", fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 1V17H25.5V1H1.5Z", fill: "#0070B8" }),
      /* @__PURE__ */ jsx("path", { id: "white", d: "M4.20416 1L25.5 15.1972V17H22.7958L1.5 2.80278L1.5 1L4.20416 1Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { id: "white_2", d: "M4.20416 17L25.5 2.80278V1L22.7958 1L1.5 15.1972L1.5 17H4.20416Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { id: "red", d: "M1.5 1V2.20185L11.6972 9H13.5L1.5 1Z", fill: "#FF1A26" }),
      /* @__PURE__ */ jsx("path", { id: "red_2", d: "M13.5 9V7.79815L23.6972 1H25.5L13.5 9Z", fill: "#FF1A26" }),
      /* @__PURE__ */ jsx("path", { id: "red_3", d: "M25.5 17V15.7981L15.3028 9H13.5L25.5 17Z", fill: "#FF1A26" }),
      /* @__PURE__ */ jsx("path", { id: "red_4", d: "M1.5 17L13.5 9V10.2019L3.30278 17H1.5Z", fill: "#FF1A26" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          id: "white cross",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16 1H11V6.5H1.5V11.5H11V17H16V11.5H25.5V6.5H16V1Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          id: "red cross",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15 1H12V7.5H1.5V10.5H12V17H15V10.5H25.5V7.5H15V1Z",
          fill: "#FF1A26"
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "star",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38 6L38.3506 7.12362L39.4216 6.7056L38.7879 7.6887L39.7727 8.29106L38.6318 8.39335L38.7889 9.5625L38 8.70695L37.2111 9.5625L37.3682 8.39335L36.2273 8.29106L37.2121 7.6887L36.5784 6.7056L37.6494 7.12362L38 6ZM42.7273 10.75L43.0779 11.8736L44.1489 11.4556L43.5152 12.4387L44.5 13.0411L43.3591 13.1434L43.5162 14.3125L42.7273 13.457L41.9383 14.3125L42.0954 13.1434L40.9545 13.0411L41.9394 12.4387L41.3057 11.4556L42.3766 11.8736L42.7273 10.75ZM33.2727 11.9375L33.6234 13.0611L34.6943 12.6431L34.0606 13.6262L35.0455 14.2286L33.9046 14.3309L34.0617 15.5L33.2727 14.6445L32.4838 15.5L32.6409 14.3309L31.5 14.2286L32.4848 13.6262L31.8511 12.6431L32.9221 13.0611L33.2727 11.9375ZM38 21.4375L38.3506 22.5611L39.4216 22.1431L38.7879 23.1262L39.7727 23.7286L38.6318 23.8309L38.7889 25L38 24.1445L37.2111 25L37.3682 23.8309L36.2273 23.7286L37.2121 23.1262L36.5784 22.1431L37.6494 22.5611L38 21.4375ZM39.7727 15.5L40.038 16.4193H40.9545L40.231 16.9812L40.4963 17.875L39.7727 17.3132L39.0492 17.8494L39.3145 16.9812L38.5909 16.4193H39.4833L39.7727 15.5Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "star_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 22L13.6923 24.2078L15.8068 23.3864L14.5556 25.3182L16.5 26.5017L14.2475 26.7027L14.5576 29L13 27.3189L11.4424 29L11.7525 26.7027L9.5 26.5017L11.4444 25.3182L10.1932 23.3864L12.3077 24.2078L13 22Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Br = createIcon({
  displayName: "Br",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "green", x: "1", y: "1", width: "48", height: "32", fill: "#00AE82" }),
    /* @__PURE__ */ jsx("path", { id: "yellow", fillRule: "evenodd", clipRule: "evenodd", d: "M25 3L5 17L25 31L45 17L25 3Z", fill: "#FBB43A" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "blue",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34 17C34 12.0294 29.9706 8 25 8C20.0294 8 16 12.0294 16 17C16 21.9706 20.0294 26 25 26C29.9706 26 34 21.9706 34 17Z",
        fill: "#0070B8"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Combined Shape",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M33.9399 18.0453C30.5509 15.0689 26.1074 13.2642 21.2424 13.2642C19.6319 13.2642 18.0676 13.4619 16.5724 13.8345C16.3705 14.3718 16.2185 14.9334 16.1221 15.5138C17.7433 15.0262 19.4623 14.7642 21.2424 14.7642C26.0328 14.7642 30.38 16.6618 33.5732 19.7464C33.748 19.2002 33.8721 18.6314 33.9399 18.0453Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Ca = createIcon({
  displayName: "Ca",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { id: "white", fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 1V33H49.5V1H1.5Z", fill: "white" }),
    /* @__PURE__ */ jsx("path", { id: "red", fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 1V33H10.5V1H1.5Z", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("path", { id: "red_2", fillRule: "evenodd", clipRule: "evenodd", d: "M40.5 1V33H49.5V1H40.5Z", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "emblem",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.2496 7L23.5467 10.1671C23.3535 10.5113 23.0072 10.4794 22.661 10.2872L21.4281 9.65057L22.347 14.5152C22.5403 15.404 21.9203 15.404 21.6143 15.0197L19.4627 12.6178L19.1134 13.8376C19.0731 13.9977 18.896 14.166 18.6303 14.1259L15.9096 13.5555L16.6242 16.1462C16.7772 16.7226 16.8965 16.9613 16.4698 17.1133L15.5 17.5678L20.1836 21.3613C20.3689 21.5047 20.4626 21.7628 20.3966 21.9966L19.9867 23.3379C21.5993 23.1526 23.0442 22.8737 24.6577 22.702C24.8001 22.6868 25.0386 22.9212 25.0376 23.0858L24.8239 28H25.608L25.4846 23.0963C25.4836 22.9317 25.6999 22.6868 25.8423 22.702C27.4558 22.8737 28.9007 23.1526 30.5133 23.3379L30.1034 21.9966C30.0374 21.7628 30.1311 21.5047 30.3164 21.3613L35 17.5678L34.0302 17.1133C33.6035 16.9613 33.7228 16.7226 33.8758 16.1462L34.5904 13.5555L31.8697 14.1259C31.604 14.166 31.4269 13.9977 31.3866 13.8376L31.0373 12.6178L28.8857 15.0197C28.5797 15.404 27.9597 15.404 28.153 14.5152L29.0718 9.65057L27.839 10.2872C27.4928 10.4794 27.1465 10.5113 26.9533 10.1671L25.2496 7Z",
        fill: "#FF1A26"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Ch = createIcon({
  displayName: "Ch",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "red", x: "1.5", y: "1", width: "48", height: "32", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("rect", { id: "Rectangle 82", x: "22.5", y: "8", width: "6", height: "18", fill: "white" }),
    /* @__PURE__ */ jsx("rect", { id: "Rectangle 83", x: "16.5", y: "14", width: "18", height: "6", fill: "white" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Cn = createIcon({
  displayName: "Cn",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "red", x: "1", y: "1", width: "48", height: "32", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Star 5",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5 16.5L6.0916 19.5676L7.64682 14.4271L3.36707 11.1824L8.73663 11.0729L10.5 6L12.2633 11.0729L17.6329 11.1824L13.3532 14.4271L14.9084 19.5676L10.5 16.5Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Star 5_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.7264 7.75167L17.342 8.1183L18.2005 6.972L17.424 5.76859L18.7795 6.23091L19.6841 5.12053L19.6633 6.55256L20.9988 7.06972L19.6304 7.49245L19.5513 8.92244L18.7264 7.75167Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Star 5_3",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.4 11.5949L22.7909 12.8911L22.4647 11.4966L21.0437 11.3179L22.2692 10.5767L22 9.17004L23.0836 10.1065L24.3383 9.4158L23.7825 10.7358L24.8271 11.7156L23.4 11.5949Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Star 5_4",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.8611 16.8846L21.5613 17.4861L22.2078 16.2081L21.2341 15.1578L22.6493 15.3778L23.3473 14.1272L23.5755 15.5411L24.9805 15.8184L23.7063 16.4724L23.8767 17.8944L22.8611 16.8846Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Star 5_5",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.7264 20.7517L17.342 21.1183L18.2005 19.972L17.424 18.7686L18.7795 19.2309L19.6841 18.1205L19.6633 19.5526L20.9988 20.0697L19.6304 20.4924L19.5513 21.9224L18.7264 20.7517Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const De = createIcon({
  displayName: "De",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "black", x: "1", y: "1", width: "48", height: "11", fill: "#0B0F14" }),
    /* @__PURE__ */ jsx("rect", { id: "red", x: "1", y: "12", width: "48", height: "10", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("rect", { id: "yellow", x: "1", y: "22", width: "48", height: "11", fill: "#FBB43A" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Dk = createIcon({
  displayName: "Dk",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "red", x: "1", y: "1", width: "48", height: "32", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("rect", { id: "white", x: "1", y: "14", width: "48", height: "6", fill: "white" }),
    /* @__PURE__ */ jsx("rect", { id: "white_2", x: "14", y: "1", width: "6", height: "32", fill: "white" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Es = createIcon({
  displayName: "Es",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { fill: "#FBB43A", d: "M1 1h48v32H1z" }),
    /* @__PURE__ */ jsx("path", { fill: "#FF1A26", d: "M1 1h48v8H1zM1 25h48v8H1z" }),
    /* @__PURE__ */ jsx("path", { fill: "#DEE5ED", fillRule: "evenodd", d: "M8 13.5V23h.5v1h-3v-1H6v-9.5h2Z", clipRule: "evenodd" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "7", cy: "13.5", fill: "#FF1A26", rx: "1", ry: ".5" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#DEE5ED",
        fillRule: "evenodd",
        d: "M8.9585 13.4107h10.0833v7.1191c0 2.4573-2.2572 3.5595-5.0416 3.5595-2.7845 0-5.0417-1.1022-5.0417-3.5595v-7.1191Z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#FF1A26", d: "M9.417 13.8214h4.5833v4.1071H9.417z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#FBB43A",
        d: "M9.417 17.9286h4.5833v2.6369c0 1.2656-1.026 2.2917-2.2916 2.2917-1.2657 0-2.2917-1.0261-2.2917-2.2917v-2.6369Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#FF1A26",
        d: "M14 17.9286h4.5833v2.6369c0 1.2656-1.026 2.2917-2.2916 2.2917-1.2657 0-2.2917-1.0261-2.2917-2.2917v-2.6369Z"
      }
    ),
    /* @__PURE__ */ jsx("ellipse", { cx: "16.292", cy: "15.875", fill: "#FF1A26", rx: "1.375", ry: "1.6429" }),
    /* @__PURE__ */ jsx("path", { fill: "#DEE5ED", fillRule: "evenodd", d: "M22 13.5V23h.5v1h-3v-1h.5v-9.5h2Z", clipRule: "evenodd" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "21", cy: "13.5", fill: "#FF1A26", rx: "1", ry: ".5" }),
    /* @__PURE__ */ jsx("ellipse", { cx: "14", cy: "11.5", fill: "#FF1A26", rx: "4", ry: "1.5" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F1F4F8"
      }
    )
  ] })
});
const Eu = createIcon({
  displayName: "Eu",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("mask", { id: "a", width: "50", height: "34", x: "0", y: "0", fill: "#000", maskUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h50v34H0z" }),
      /* @__PURE__ */ jsx("path", { d: "M1 1h48v32H1V1Z" }),
      /* @__PURE__ */ jsx("path", { d: "M23.6144 10.2641 24.9999 9.3l1.3855.9641-.4888-1.6156 1.3451-1.01975-1.6876-.03439L24.9999 6l-.5542 1.59436-1.6876.03439 1.3451 1.01975-.4888 1.6156ZM27.168 10.4738l1.6819-.1422.7178 1.5277.3845-1.6436 1.6748-.2106-1.4443-.87353.3172-1.65785-1.2771 1.10365-1.4787-.814.655 1.55566-1.2311 1.15477ZM31.6683 13.15l-1.5277-.7178 1.6436-.3845.2106-1.6748.8735 1.4443 1.6579-.3172-1.1037 1.2771.814 1.4787-1.5556-.655-1.1548 1.2311.1422-1.6819ZM31.7358 15.6145 32.6999 17l-.9641 1.3855 1.6156-.4888 1.0198 1.3451.0343-1.6876L35.9999 17l-1.5944-.5542-.0343-1.6876-1.0198 1.3451-1.6156-.4888ZM31.6683 20.85l-.1422-1.6819 1.1548 1.2311 1.5556-.655-.814 1.4787L34.5262 22.5l-1.6579-.3172-.8735 1.4443-.2106-1.6748-1.6436-.3845 1.5277-.7178ZM29.5677 22.1407l-.7178 1.5277-1.6819-.1422 1.2311 1.1548-.655 1.5556 1.4787-.814 1.2771 1.1037-.3172-1.6579 1.4443-.8735-1.6748-.2106-.3845-1.6436ZM24.9999 24.7l1.3855-.9641-.4888 1.6156 1.3451 1.0198-1.6876.0343L24.9999 28l-.5542-1.5944-1.6876-.0343 1.3451-1.0198-.4888-1.6156 1.3855.9641ZM22.8318 23.5262l-1.6819.1422-.7178-1.5277-.3845 1.6436-1.6748.2106 1.4443.8735-.3172 1.6579 1.2771-1.1037 1.4787.814-.655-1.5556 1.2311-1.1548ZM18.3315 20.85l1.5277.7178-1.6436.3845-.2106 1.6748-.8735-1.4443-1.6579.3172 1.1037-1.2771-.814-1.4787 1.5556.655 1.1548-1.2311-.1422 1.6819ZM18.264 18.3855 17.2999 17l.9641-1.3855-1.6156.4888-1.0198-1.3451-.0343 1.6876L13.9999 17l1.5944.5542.0343 1.6876 1.0198-1.3451 1.6156.4888ZM18.3315 13.15l.1422 1.6819-1.1548-1.2311-1.5556.655.814-1.4787L15.4736 11.5l1.6579.3172.8735-1.4443.2106 1.6748 1.6436.3845-1.5277.7178ZM20.4321 11.8593l.7178-1.5277 1.6819.1422-1.2311-1.15477.655-1.55566-1.4787.814-1.2771-1.10365.3172 1.65785-1.4443.87353 1.6748.2106.3845 1.6436Z" })
    ] }),
    /* @__PURE__ */ jsx("path", { fill: "#0D3073", d: "M1 1h48v32H1V1Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#FBB43A",
        d: "M23.6144 10.2641 24.9999 9.3l1.3855.9641-.4888-1.6156 1.3451-1.01975-1.6876-.03439L24.9999 6l-.5542 1.59436-1.6876.03439 1.3451 1.01975-.4888 1.6156ZM27.168 10.4738l1.6819-.1422.7178 1.5277.3845-1.6436 1.6748-.2106-1.4443-.87353.3172-1.65785-1.2771 1.10365-1.4787-.814.655 1.55566-1.2311 1.15477ZM31.6683 13.15l-1.5277-.7178 1.6436-.3845.2106-1.6748.8735 1.4443 1.6579-.3172-1.1037 1.2771.814 1.4787-1.5556-.655-1.1548 1.2311.1422-1.6819ZM31.7358 15.6145 32.6999 17l-.9641 1.3855 1.6156-.4888 1.0198 1.3451.0343-1.6876L35.9999 17l-1.5944-.5542-.0343-1.6876-1.0198 1.3451-1.6156-.4888ZM31.6683 20.85l-.1422-1.6819 1.1548 1.2311 1.5556-.655-.814 1.4787L34.5262 22.5l-1.6579-.3172-.8735 1.4443-.2106-1.6748-1.6436-.3845 1.5277-.7178ZM29.5677 22.1407l-.7178 1.5277-1.6819-.1422 1.2311 1.1548-.655 1.5556 1.4787-.814 1.2771 1.1037-.3172-1.6579 1.4443-.8735-1.6748-.2106-.3845-1.6436ZM24.9999 24.7l1.3855-.9641-.4888 1.6156 1.3451 1.0198-1.6876.0343L24.9999 28l-.5542-1.5944-1.6876-.0343 1.3451-1.0198-.4888-1.6156 1.3855.9641ZM22.8318 23.5262l-1.6819.1422-.7178-1.5277-.3845 1.6436-1.6748.2106 1.4443.8735-.3172 1.6579 1.2771-1.1037 1.4787.814-.655-1.5556 1.2311-1.1548ZM18.3315 20.85l1.5277.7178-1.6436.3845-.2106 1.6748-.8735-1.4443-1.6579.3172 1.1037-1.2771-.814-1.4787 1.5556.655 1.1548-1.2311-.1422 1.6819ZM18.264 18.3855 17.2999 17l.9641-1.3855-1.6156.4888-1.0198-1.3451-.0343 1.6876L13.9999 17l1.5944.5542.0343 1.6876 1.0198-1.3451 1.6156.4888ZM18.3315 13.15l.1422 1.6819-1.1548-1.2311-1.5556.655.814-1.4787L15.4736 11.5l1.6579.3172.8735-1.4443.2106 1.6748 1.6436.3845-1.5277.7178ZM20.4321 11.8593l.7178-1.5277 1.6819.1422-1.2311-1.15477.655-1.55566-1.4787.814-1.2771-1.10365.3172 1.65785-1.4443.87353 1.6748.2106.3845 1.6436Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { stroke: "#F1F4F8", strokeWidth: "2", d: "M1 1h48v32H1V1Z", mask: "url(#a)" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "#F1F4F8",
        strokeWidth: "2",
        d: "M23.6144 10.2641 24.9999 9.3l1.3855.9641-.4888-1.6156 1.3451-1.01975-1.6876-.03439L24.9999 6l-.5542 1.59436-1.6876.03439 1.3451 1.01975-.4888 1.6156ZM27.168 10.4738l1.6819-.1422.7178 1.5277.3845-1.6436 1.6748-.2106-1.4443-.87353.3172-1.65785-1.2771 1.10365-1.4787-.814.655 1.55566-1.2311 1.15477ZM31.6683 13.15l-1.5277-.7178 1.6436-.3845.2106-1.6748.8735 1.4443 1.6579-.3172-1.1037 1.2771.814 1.4787-1.5556-.655-1.1548 1.2311.1422-1.6819ZM31.7358 15.6145 32.6999 17l-.9641 1.3855 1.6156-.4888 1.0198 1.3451.0343-1.6876L35.9999 17l-1.5944-.5542-.0343-1.6876-1.0198 1.3451-1.6156-.4888ZM31.6683 20.85l-.1422-1.6819 1.1548 1.2311 1.5556-.655-.814 1.4787L34.5262 22.5l-1.6579-.3172-.8735 1.4443-.2106-1.6748-1.6436-.3845 1.5277-.7178ZM29.5677 22.1407l-.7178 1.5277-1.6819-.1422 1.2311 1.1548-.655 1.5556 1.4787-.814 1.2771 1.1037-.3172-1.6579 1.4443-.8735-1.6748-.2106-.3845-1.6436ZM24.9999 24.7l1.3855-.9641-.4888 1.6156 1.3451 1.0198-1.6876.0343L24.9999 28l-.5542-1.5944-1.6876-.0343 1.3451-1.0198-.4888-1.6156 1.3855.9641ZM22.8318 23.5262l-1.6819.1422-.7178-1.5277-.3845 1.6436-1.6748.2106 1.4443.8735-.3172 1.6579 1.2771-1.1037 1.4787.814-.655-1.5556 1.2311-1.1548ZM18.3315 20.85l1.5277.7178-1.6436.3845-.2106 1.6748-.8735-1.4443-1.6579.3172 1.1037-1.2771-.814-1.4787 1.5556.655 1.1548-1.2311-.1422 1.6819ZM18.264 18.3855 17.2999 17l.9641-1.3855-1.6156.4888-1.0198-1.3451-.0343 1.6876L13.9999 17l1.5944.5542.0343 1.6876 1.0198-1.3451 1.6156.4888ZM18.3315 13.15l.1422 1.6819-1.1548-1.2311-1.5556.655.814-1.4787L15.4736 11.5l1.6579.3172.8735-1.4443.2106 1.6748 1.6436.3845-1.5277.7178ZM20.4321 11.8593l.7178-1.5277 1.6819.1422-1.2311-1.15477.655-1.55566-1.4787.814-1.2771-1.10365.3172 1.65785-1.4443.87353 1.6748.2106.3845 1.6436Z",
        mask: "url(#a)"
      }
    )
  ] })
});
const Fi = createIcon({
  displayName: "Fi",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "white", x: "1.5", y: "1", width: "48", height: "32", fill: "white" }),
    /* @__PURE__ */ jsx("path", { id: "blue", fillRule: "evenodd", clipRule: "evenodd", d: "M14.5 1H20.5V33H14.5V1Z", fill: "#0070B8" }),
    /* @__PURE__ */ jsx("path", { id: "blue_2", fillRule: "evenodd", clipRule: "evenodd", d: "M49.5 14V20H1.5V14H49.5Z", fill: "#0070B8" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Fr = createIcon({
  displayName: "Fr",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "blue", x: "1", y: "1", width: "16", height: "32", fill: "#0070B8" }),
    /* @__PURE__ */ jsx("rect", { id: "white", x: "17", y: "1", width: "16", height: "32", fill: "white" }),
    /* @__PURE__ */ jsx("rect", { id: "red", x: "33", y: "1", width: "16", height: "32", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Gb = createIcon({
  displayName: "Gb",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { id: "blue dark", fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 1V33H49.5V1H1.5Z", fill: "#0070B8" }),
    /* @__PURE__ */ jsx("path", { id: "white", d: "M6.90833 1L49.5 29.3944V33H44.0917L1.5 4.60555L1.5 1L6.90833 1Z", fill: "white" }),
    /* @__PURE__ */ jsx("path", { id: "white_2", d: "M6.90833 33L49.5 4.60555V1L44.0917 1L1.5 29.3944L1.5 33H6.90833Z", fill: "white" }),
    /* @__PURE__ */ jsx("path", { id: "red", d: "M1.5 1V3.4037L21.8944 17H25.5L1.5 1Z", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("path", { id: "red_2", d: "M25.5 17V14.5963L45.8944 1H49.5L25.5 17Z", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("path", { id: "red_3", d: "M49.5 33V30.5963L29.1056 17H25.5L49.5 33Z", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("path", { id: "red_4", d: "M1.5 33L25.5 17V19.4037L5.10555 33H1.5Z", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "white cross",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30.5 1H20.5V12H1.5V22H20.5V33H30.5V22H49.5V12H30.5V1Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "red cross",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.5 1H22.5V14H1.5V20H22.5V33H28.5V20H49.5V14H28.5V1Z",
        fill: "#FF1A26"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Gr = createIcon({
  displayName: "Gr",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { id: "blue", fillRule: "evenodd", clipRule: "evenodd", d: "M1 1V33H49V1H1Z", fill: "#0070B8" }),
    /* @__PURE__ */ jsx("path", { id: "white", fillRule: "evenodd", clipRule: "evenodd", d: "M19 4.5V8H49V4.5L19 4.5Z", fill: "white" }),
    /* @__PURE__ */ jsx("path", { id: "white_2", fillRule: "evenodd", clipRule: "evenodd", d: "M19 11.5V15H49V11.5L19 11.5Z", fill: "white" }),
    /* @__PURE__ */ jsx("path", { id: "white_3", fillRule: "evenodd", clipRule: "evenodd", d: "M1 19V22.5H49V19H1Z", fill: "white" }),
    /* @__PURE__ */ jsx("path", { id: "white_4", fillRule: "evenodd", clipRule: "evenodd", d: "M1 26V29.5H49V26H1Z", fill: "white" }),
    /* @__PURE__ */ jsx("path", { id: "white_5", fillRule: "evenodd", clipRule: "evenodd", d: "M1 8V11.5H19V8H1Z", fill: "white" }),
    /* @__PURE__ */ jsx("path", { id: "white_6", fillRule: "evenodd", clipRule: "evenodd", d: "M8.25 1V19H11.75V1H8.25Z", fill: "white" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Ie = createIcon({
  displayName: "Ie",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "white", x: "1.5", y: "1", width: "48", height: "32", fill: "white" }),
    /* @__PURE__ */ jsx("rect", { id: "green", x: "1.5", y: "1", width: "16", height: "32", fill: "#00AE82" }),
    /* @__PURE__ */ jsx("rect", { id: "orange", x: "33.5", y: "1", width: "16", height: "32", fill: "#E87E04" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const In = createIcon({
  displayName: "In",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "green", x: "1", y: "23", width: "48", height: "10", fill: "#00AE82" }),
    /* @__PURE__ */ jsx("rect", { id: "white", x: "1", y: "11", width: "48", height: "12", fill: "white" }),
    /* @__PURE__ */ jsx("rect", { id: "orange", x: "1", y: "1", width: "48", height: "10", fill: "#E87E04" }),
    /* @__PURE__ */ jsx("circle", { id: "Oval 15", cx: "25", cy: "17", r: "5.5", fill: "#0070B8" }),
    /* @__PURE__ */ jsx("circle", { id: "Oval 15_2", cx: "25", cy: "17", r: "4.5", fill: "white" }),
    /* @__PURE__ */ jsx("circle", { id: "Oval 15_3", cx: "25", cy: "17", r: "1.5", fill: "#0070B8" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Int = createIcon({
  displayName: "Int",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { id: "Shape", fillRule: "evenodd", clipRule: "evenodd", d: "M1 1H49V33H1V1Z", fill: "#4D98FF" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Combined Shape",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25 30C32.1797 30 38 24.1797 38 17C38 9.8203 32.1797 4 25 4C17.8203 4 12 9.8203 12 17C12 24.1797 17.8203 30 25 30ZM25 28C31.0751 28 36 23.0751 36 17C36 10.9249 31.0751 6 25 6C18.9249 6 14 10.9249 14 17C14 23.0751 18.9249 28 25 28Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx("path", { id: "Rectangle 105", fillRule: "evenodd", clipRule: "evenodd", d: "M14 11H36L37 13H13L14 11Z", fill: "white" }),
    /* @__PURE__ */ jsx("path", { id: "Rectangle 105_2", fillRule: "evenodd", clipRule: "evenodd", d: "M13 21H37L36 23H14L13 21Z", fill: "white" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Combined Shape_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25 30C28.866 30 32 24.1797 32 17C32 9.8203 28.866 4 25 4C21.134 4 18 9.8203 18 17C18 24.1797 21.134 30 25 30ZM25 28C27.7614 28 30 23.0751 30 17C30 10.9249 27.7614 6 25 6C22.2386 6 20 10.9249 20 17C20 23.0751 22.2386 28 25 28Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const It = createIcon({
  displayName: "It",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "white", x: "17", y: "1", width: "16", height: "32", fill: "white" }),
    /* @__PURE__ */ jsx("rect", { id: "red", x: "33", y: "1", width: "16", height: "32", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("rect", { id: "green", x: "1", y: "1", width: "16", height: "32", fill: "#00AE82" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Nl = createIcon({
  displayName: "Nl",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "white", x: "1", y: "12", width: "48", height: "10", fill: "white" }),
    /* @__PURE__ */ jsx("rect", { id: "red", x: "1", y: "1", width: "48", height: "11", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("rect", { id: "blue", x: "1", y: "22", width: "48", height: "11", fill: "#0070B8" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const No = createIcon({
  displayName: "No",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "red", x: "1", y: "1", width: "48", height: "32", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("path", { id: "white", fillRule: "evenodd", clipRule: "evenodd", d: "M49 12V22H1V12H49Z", fill: "white" }),
    /* @__PURE__ */ jsx("path", { id: "white_2", fillRule: "evenodd", clipRule: "evenodd", d: "M12 1H22V33H12V1Z", fill: "white" }),
    /* @__PURE__ */ jsx("path", { id: "blue", fillRule: "evenodd", clipRule: "evenodd", d: "M49 14V20H1V14H49Z", fill: "#0070B8" }),
    /* @__PURE__ */ jsx("path", { id: "blue_2", fillRule: "evenodd", clipRule: "evenodd", d: "M14 1H20V33H14V1Z", fill: "#0070B8" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Nz = createIcon({
  displayName: "Nz",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("g", { children: [
      /* @__PURE__ */ jsx("rect", { width: "48", height: "32", x: "1", y: "1", fill: "#0070B8" }),
      /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("path", { fill: "#0070B8", fillRule: "evenodd", d: "M1 1v16h24V1H1Z", clipRule: "evenodd" }),
        /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M3.7042 1 25 15.1972V17h-2.7042L1 2.8028V1h2.7042Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M3.7042 17 25 2.8028V1h-2.7042L1 15.1972V17h2.7042Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#E6000C",
            d: "M1 1v1.2018L11.1972 9H13L1 1ZM13 9V7.7981L23.1972 1H25L13 9ZM25 17v-1.2019L14.8028 9H13l12 8ZM1 17l12-8v1.2019L2.8028 17H1Z"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#fff", fillRule: "evenodd", d: "M15.5 1h-5v5.5H1v5h9.5V17h5v-5.5H25v-5h-9.5V1Z", clipRule: "evenodd" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#E6000C",
            fillRule: "evenodd",
            d: "M14.5 1h-3v6.5H1v3h10.5V17h3v-6.5H25v-3H14.5V1Z",
            clipRule: "evenodd"
          }
        )
      ] }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m36.7562 4.483.6115 2.109h2.0717l-1.6439 1.2703.6089 2.0413-1.6566-1.2802-1.6523 1.2188.6081-1.9805-1.6431-1.2698h2.0285l.6672-2.109Zm6.6115 8.1089-.6115-2.109-.6672 2.109h-2.0285l1.6431 1.2698-.6081 1.9805 1.6523-1.2188 1.6566 1.2802-.6089-2.0413 1.6439-1.2704h-2.0717Zm-6 12-.6115-2.109-.6672 2.109h-2.0285l1.6431 1.2698-.6081 1.9805 1.6523-1.2188 1.6566 1.2802-.6089-2.0413 1.6439-1.2704h-2.0717Zm-6-10.5-.6115-2.109-.6672 2.109h-2.0285l1.6431 1.2698-.6081 1.9805 1.6523-1.2188 1.6566 1.2802-.6089-2.0413 1.6439-1.2704h-2.0717Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E6000C",
          fillRule: "evenodd",
          d: "m36.342 6.7871-.143.1048h-1.2595l1.0298.796.0517.1626-.3717 1.2105 1.0117-.7463.1808.002 1.0089.7797-.372-1.247.052-.1616 1.0299-.7959h-1.3054l-.1441-.1082-.3673-1.2666-.4018 1.27Zm5.857 6.1048.143-.1047.4018-1.2701.3673 1.2666.1441.1082h1.3054l-1.0299.7959-.052.1616.372 1.247-1.0089-.7796-.1808-.0021-1.0117.7463.3717-1.2105-.0517-.1627-1.0298-.7959h1.2595Zm-6 12 .143-.1047.4018-1.2701.3673 1.2666.1441.1082h1.3054l-1.0299.7959-.052.1616.372 1.247-1.0089-.7796-.1808-.0021-1.0117.7463.3717-1.2105-.0517-.1627-1.0298-.7959h1.2595Zm-6-10.5.143-.1047.4018-1.2701.3673 1.2666.1441.1082h1.3054l-1.0299.7959-.052.1616.372 1.247-1.0089-.7796-.1808-.0021-1.0117.7463.3717-1.2105-.0517-.1627-1.0298-.7959h1.2595Z",
          clipRule: "evenodd"
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Pl = createIcon({
  displayName: "Pl",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "red", x: "1", y: "17", width: "48", height: "16", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("rect", { id: "white", x: "1", y: "1", width: "48", height: "16", fill: "white" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Pt = createIcon({
  displayName: "Pt",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "red", x: "17", y: "1", width: "32", height: "32", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("rect", { id: "green", x: "1", y: "1", width: "16", height: "32", fill: "#00AE82" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Combined Shape",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17 27C22.5228 27 27 22.5228 27 17C27 11.4772 22.5228 7 17 7C11.4772 7 7 11.4772 7 17C7 22.5228 11.4772 27 17 27ZM17 25C21.4183 25 25 21.4183 25 17C25 12.5817 21.4183 9 17 9C12.5817 9 9 12.5817 9 17C9 21.4183 12.5817 25 17 25Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Rectangle 56",
        d: "M22.5 11.5V18C22.5 21.0376 20.0376 23.5 17 23.5C13.9624 23.5 11.5 21.0376 11.5 18V11.5H22.5Z",
        fill: "#FBB43A"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Rectangle 56_2",
        d: "M12 12H22V18C22 20.7614 19.7614 23 17 23C14.2386 23 12 20.7614 12 18V12Z",
        fill: "#FF1A26"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Path",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 18C14 19.6569 15.3431 21 17 21C18.6569 21 20 19.6569 20 18V14H14V18Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx("rect", { id: "Rectangle 57", x: "16.5", y: "15", width: "1", height: "1", fill: "#4D98FF" }),
    /* @__PURE__ */ jsx("rect", { id: "Rectangle 57_2", x: "15", y: "17", width: "1", height: "1", fill: "#4D98FF" }),
    /* @__PURE__ */ jsx("rect", { id: "Rectangle 57_3", x: "18", y: "17", width: "1", height: "1", fill: "#4D98FF" }),
    /* @__PURE__ */ jsx("rect", { id: "Rectangle 57_4", x: "16.5", y: "19", width: "1", height: "1", fill: "#4D98FF" }),
    /* @__PURE__ */ jsx("rect", { id: "Rectangle 57_5", x: "16.5", y: "17", width: "1", height: "1", fill: "#4D98FF" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Ro = createIcon({
  displayName: "Ro",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "red", x: "33.5", y: "1", width: "16", height: "32", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("rect", { id: "yellow", x: "17.5", y: "1", width: "16", height: "32", fill: "#FBB43A" }),
    /* @__PURE__ */ jsx("rect", { id: "blue", x: "1.5", y: "1", width: "16", height: "32", fill: "#0070B8" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const RoundedBr = createIcon({
  displayName: "RoundedBr",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("circle", { cx: "12", cy: "12", r: "12", fill: "#4CAF50" }),
    /* @__PURE__ */ jsx("path", { d: "M21.862 11.72L11.931 18.44L2 11.72L11.931 5L21.862 11.72Z", fill: "#FFEB3B" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M11.931 7.80005C9.79697 7.80005 8.06897 9.55405 8.06897 11.72C8.06897 13.886 9.79697 15.64 11.931 15.64C14.065 15.64 15.793 13.886 15.793 11.72C15.793 9.55405 14.065 7.80005 11.931 7.80005Z",
        fill: "#3F51B5"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8.51295 9.89788C8.32495 10.2579 8.19595 10.6529 8.12695 11.0679C9.37095 10.9129 12.75 10.7529 15.595 12.9579C15.7259 12.5583 15.7928 12.1404 15.793 11.7199V11.7159C13.067 9.84088 10.086 9.76588 8.51295 9.89788Z",
        fill: "white"
      }
    )
  ] })
});
const RoundedEarth = createIcon({
  displayName: "RoundedEarth",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 0.571533C5.68816 0.571533 0.571411 5.68828 0.571411 12.0001C0.571411 18.3119 5.68816 23.4287 12 23.4287C18.3118 23.4287 23.4286 18.3119 23.4286 12.0001C23.4286 5.68828 18.3118 0.571533 12 0.571533Z",
        fill: "#1565C0"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.34284 12.5716C6.85713 12.5716 6.85713 12.1145 6.85713 11.4288C6.85713 11.3915 6.85679 11.3532 6.85644 11.314C6.85044 10.6342 6.84232 9.71449 8.57141 9.71449C9.31427 9.71449 10.2857 9.71449 10.2857 8.57164V5.7145C10.2857 5.54307 10.2286 4.80021 9.0857 4.80021C8.11427 4.80021 7.37141 4.62878 7.37141 3.94307C7.37141 3.42878 7.77141 2.22878 8.57141 1.14307C4.34284 2.45735 1.25713 6.1145 0.685697 10.5716L0.571411 11.4288H5.14284C5.62585 11.4288 5.78224 11.7917 5.91877 12.1085C6.02452 12.3539 6.11836 12.5716 6.34284 12.5716ZM16.7428 6.57164L15.6 7.42878C15.4286 7.60021 15.3714 7.82878 15.4286 8.05735L15.9428 8.68592C16 8.91449 15.8857 9.20021 15.6571 9.3145C15.6 9.34878 15.5268 9.38992 15.4464 9.43518C15.1246 9.61621 14.6857 9.86307 14.6857 10.0002C14.6857 10.4002 14.9714 11.3716 15.2 11.3716C16.2099 11.3716 16.2912 11.1116 16.4073 10.7398C16.4949 10.4595 16.6024 10.1155 17.1428 9.77164C17.8857 9.3145 19.0857 9.08592 19.3714 9.08592H20.5143V17.0859H16.5143C16.5143 17.0859 17.2 18.1716 17.8286 19.3716C18.1143 19.9431 18.8 21.0859 18.8 21.0859C21.7143 18.8574 23.3714 15.4859 23.3714 11.9431C23.3714 8.28592 21.6 4.97164 18.9143 2.91449L17.2571 5.82878C17.1428 6.17164 16.9714 6.40021 16.7428 6.57164ZM9.4857 15.0288C10.2857 16.0002 10.7428 16.0002 11.4286 16.0002V17.5431C11.4286 17.5431 10.9714 18.6288 10.8571 18.8574C10.8299 18.9389 10.7315 19.1209 10.5943 19.3746C10.1548 20.1871 9.31701 21.7361 9.14284 23.0859C8.57141 22.9145 7.99998 22.6859 7.42855 22.4574V18.8574L6.2857 14.8574L6.85713 14.2859H7.31427H8.22855C8.62855 14.2859 9.14284 14.6859 9.4857 15.0288Z",
        fill: "#43A047"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.53563 13.7806C2.86153 13.2754 2.04646 12.6646 1.71424 12.0002L0.685669 10.4573C0.91424 8.22877 2.11424 6.17163 2.11424 6.17163L2.28567 6.22877C3.42853 6.8002 3.99995 8.0002 3.99995 8.8002C3.99995 9.20925 4.26023 9.57926 4.53237 9.96612C4.83048 10.3899 5.14281 10.8339 5.14281 11.3716C4.28567 11.3716 3.99995 11.7716 3.99995 12.1145V12.6859C3.99995 12.9716 4.22853 13.1431 4.57138 13.1431C5.02853 13.1431 5.08567 13.2573 5.08567 13.5431C5.08567 13.8288 5.37138 14.2859 5.71424 14.2859H6.79995C6.79995 16.5145 7.82853 17.1431 8.97138 17.1431C11.1428 17.1431 11.4285 16.0002 11.4285 16.0002C11.7714 16.0002 12 16.6288 12 16.8573C12 18.7431 10.8571 18.8573 10.8571 18.8573C9.94281 18.8573 7.99995 20.0002 7.99995 21.7145V22.6859L6.8571 22.1716V21.1431C6.8571 20.647 6.64178 19.9787 6.39806 19.2222C6.08029 18.2359 5.71424 17.0997 5.71424 16.0002C5.71424 15.0887 4.66021 14.468 4.00149 14.0801C3.83426 13.9817 3.69251 13.8982 3.59995 13.8288C3.57867 13.8128 3.55722 13.7967 3.53563 13.7806ZM20 11.4288C20 9.71449 19.4285 9.14306 19.4285 9.14306C19.6962 8.93712 19.8452 8.50854 20.0065 8.04453C20.2927 7.22101 20.6178 6.28592 21.7142 6.28592H21.8857L22.0571 6.57163C22.9142 8.17163 23.4285 10.0573 23.4285 12.0002C23.4285 14.8573 22.3428 17.4859 20.6285 19.4859L20.5714 19.4288C18.8571 17.1431 16.5714 17.1431 16.5714 17.1431C16.5714 17.1431 14.2857 16.9145 14.2857 14.8573C14.2857 14.2288 14.2857 12.5716 17.1428 12.5716C18.8571 12.5716 20 12.0002 20 11.4288Z",
        fill: "#7CB342"
      }
    )
  ] })
});
const RoundedEu = createIcon({
  displayName: "RoundedEu",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("circle", { cx: "12", cy: "12", r: "12", fill: "#3F51B5" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.385 4.33991L12 3.55591L11.615 4.33991L10.757 4.46591L11.378 5.07591L11.23 5.94091L12 5.53091L12.771 5.94091L12.622 5.07591L13.247 4.46491L12.385 4.33991ZM8.68803 5.45491L8.30203 4.66991L7.92003 5.45491L7.05903 5.57991L7.68103 6.19091L7.53503 7.05591L8.30303 6.64591L9.07303 7.05591L8.92803 6.19091L9.54803 5.57991L8.68803 5.45491ZM5.67703 7.10791L6.05903 7.89191L6.92003 8.02091L6.29903 8.62791L6.44403 9.49291L5.67703 9.08691L4.90703 9.49291L5.05603 8.62791L4.43403 8.02091L5.29203 7.89191L5.67703 7.10791ZM15.312 5.45491L15.697 4.66991H15.698L16.08 5.45491L16.941 5.57991L16.319 6.19091L16.465 7.05591L15.697 6.64591L14.927 7.05591L15.072 6.19091L14.452 5.57991L15.312 5.45491ZM8.30303 16.5349L8.68903 17.3189L9.54903 17.4479L8.92903 18.0589L9.07403 18.9199L8.30403 18.5139L7.53603 18.9199L7.68203 18.0589L7.06003 17.4479L7.92103 17.3189L8.30303 16.5349ZM15.313 17.3189L15.699 16.5349L16.081 17.3189L16.942 17.4479L16.32 18.0589L16.466 18.9199L15.698 18.5139L14.928 18.9199L15.073 18.0589L14.453 17.4479L15.313 17.3189ZM18.324 7.10791L17.942 7.89191L17.081 8.02091L17.702 8.62791L17.557 9.49291L18.324 9.08691L19.094 9.49291L18.945 8.62791L19.567 8.02091L18.709 7.89191L18.324 7.10791ZM6.05903 14.8469L5.67703 14.0589L5.29203 14.8469L4.43403 14.9719L5.05603 15.5839L4.90703 16.4439L5.67703 16.0379L6.44403 16.4439L6.29903 15.5829L6.92003 14.9719L6.05903 14.8469ZM18.323 14.0589L17.941 14.8469L17.08 14.9719L17.701 15.5829L17.556 16.4439L18.323 16.0379L19.093 16.4439L18.944 15.5839L19.566 14.9719L18.708 14.8469L18.323 14.0589ZM19.583 11.5939L19.198 10.8059L18.816 11.5939L17.955 11.7189L18.58 12.3299L18.431 13.1939L19.201 12.7839L19.969 13.1939L19.823 12.3289L20.444 11.7189L19.583 11.5939ZM4.80203 10.8059L5.18403 11.5939L6.04503 11.7189L5.42403 12.3289L5.56903 13.1939L4.80203 12.7839L4.03203 13.1939L4.18103 12.3299L3.55603 11.7189L4.41603 11.5939L4.80203 10.8059ZM12.385 18.8439L12 18.0589L11.615 18.8439L10.757 18.9689L11.378 19.5799L11.23 20.4439L12 20.0379L12.771 20.4439L12.622 19.5789L13.247 18.9689L12.385 18.8439Z",
        fill: "#FFEB3B"
      }
    )
  ] })
});
const RoundedUs = createIcon({
  displayName: "RoundedUs",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("ellipse", { cx: "11.921", cy: "12", rx: "11.881", ry: "12", fill: "white" }),
    /* @__PURE__ */ jsx("mask", { id: "mask0_0_2874", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "24", height: "24", children: /* @__PURE__ */ jsx("ellipse", { cx: "11.921", cy: "12", rx: "11.881", ry: "12", fill: "white" }) }),
    /* @__PURE__ */ jsxs("g", { mask: "url(#mask0_0_2874)", children: [
      /* @__PURE__ */ jsx("path", { d: "M-7.44446 0H31.5555V24H-7.44446V0Z", fill: "#ECEFF1" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.72827 0H20.1008V2.66667H2.72827V0ZM0 5.33333H24V8H0V5.33333ZM24 10.6667H0V13.3333H24V10.6667ZM0 16H24V18.6667H0V16ZM20.1008 21.3333H2.72827V24H20.1008V21.3333Z",
          fill: "#F44336"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M-7.44446 0H11.5555V13H-7.44446V0Z", fill: "#3F51B5" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.28131 2.89818L5.85934 2L5.43736 2.89818L4.49225 3.04182L5.17579 3.74182L5.01357 4.72727L5.85934 4.26182L6.70511 4.72727L6.54288 3.74182L7.22643 3.04182L6.28131 2.89818ZM9.69903 2.89818L9.27706 2L8.85508 2.89818L7.90997 3.04182L8.59351 3.74182L8.43129 4.72727L9.27706 4.26182L10.1228 4.72727L9.9606 3.74182L10.6441 3.04182L9.69903 2.89818ZM2.21377 9.27273L2.63574 10.1709L3.58086 10.3145L2.89731 11.0145L3.05954 12L2.21377 11.5345L1.368 12L1.53022 11.0145L0.84668 10.3145L1.79179 10.1709L2.21377 9.27273ZM6.28131 10.1709L5.85934 9.27273L5.43736 10.1709L4.49225 10.3145L5.17579 11.0145L5.01357 12L5.85934 11.5345L6.70511 12L6.54288 11.0145L7.22643 10.3145L6.28131 10.1709ZM9.27706 9.27273L9.69903 10.1709L10.6441 10.3145L9.9606 11.0145L10.1228 12L9.27706 11.5345L8.43129 12L8.59351 11.0145L7.90997 10.3145L8.85508 10.1709L9.27706 9.27273ZM3.54714 6.53455L3.12516 5.63636L2.70319 6.53455L1.75807 6.67818L2.44162 7.37818L2.27939 8.36364L3.12516 7.89818L3.97093 8.36364L3.80871 7.37818L4.49225 6.67818L3.54714 6.53455ZM6.77073 5.63636L7.19271 6.53455L8.13782 6.67818L7.45427 7.37818L7.6165 8.36364L6.77073 7.89818L5.92496 8.36364L6.08719 7.37818L5.40364 6.67818L6.34876 6.53455L6.77073 5.63636ZM10.6104 6.53455L10.1885 5.63636L9.76648 6.53455L8.82136 6.67818L9.50491 7.37818L9.34268 8.36364L10.1885 7.89818L11.0342 8.36364L10.872 7.37818L11.5555 6.67818L10.6104 6.53455Z",
          fill: "white"
        }
      )
    ] })
  ] })
});
const Ru = createIcon({
  displayName: "Ru",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "white", x: "1.5", y: "1", width: "48", height: "10", fill: "white" }),
    /* @__PURE__ */ jsx("rect", { id: "blue", x: "1.5", y: "11", width: "48", height: "12", fill: "#0070B8" }),
    /* @__PURE__ */ jsx("rect", { id: "red", x: "1.5", y: "23", width: "48", height: "10", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Se = createIcon({
  displayName: "Se",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "blue", x: "1.5", y: "1", width: "48", height: "32", fill: "#0070B8" }),
    /* @__PURE__ */ jsx("rect", { id: "Rectangle 80", x: "13.5", y: "1", width: "6", height: "32", fill: "#FBB43A" }),
    /* @__PURE__ */ jsx("rect", { id: "Rectangle 81", x: "1.5", y: "14", width: "48", height: "6", fill: "#FBB43A" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Us = createIcon({
  displayName: "Us",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { id: "white", fillRule: "evenodd", clipRule: "evenodd", d: "M1 1V33H49V1H1Z", fill: "white" }),
    /* @__PURE__ */ jsx("path", { id: "red", fillRule: "evenodd", clipRule: "evenodd", d: "M25 1V3.5H49V1H25Z", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("path", { id: "red_2", fillRule: "evenodd", clipRule: "evenodd", d: "M25 10.8333V13.3333H49V10.8333H25Z", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "red_3",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 20.6667V23.1667H49V20.6667L1 20.6667Z",
        fill: "#FF1A26"
      }
    ),
    /* @__PURE__ */ jsx("path", { id: "red_4", fillRule: "evenodd", clipRule: "evenodd", d: "M25 5.91675V8.41675H49V5.91675H25Z", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("path", { id: "red_5", fillRule: "evenodd", clipRule: "evenodd", d: "M25 15.75V18.25H49V15.75L25 15.75Z", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("path", { id: "red_6", fillRule: "evenodd", clipRule: "evenodd", d: "M1 25.5833V28.0833H49V25.5833H1Z", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("path", { id: "red_7", fillRule: "evenodd", clipRule: "evenodd", d: "M1 30.5V33H49V30.5H1Z", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("path", { fill: "#0070B8", fillRule: "evenodd", d: "M1 1v17.25h24V1H1Z", clipRule: "evenodd" }),
    /* @__PURE__ */ jsxs("g", { fill: "#fff", fillRule: "evenodd", clipRule: "evenodd", children: [
      /* @__PURE__ */ jsx("path", { d: "m2.99988 4-.58778.30902.11226-.65451-.47553-.46353.65716-.09549L2.99988 2.5l.2939.59549.65716.09549-.47553.46353.11226.65451L2.99988 4ZM6.99988 4l-.58778.30902.11226-.65451-.47553-.46353.65716-.09549L6.99988 2.5l.2939.59549.65716.09549-.47553.46353.11226.65451L6.99988 4ZM10.9999 4l-.5878.30902.1123-.65451-.4756-.46353.6572-.09549.2939-.59549.2939.59549.6571.09549-.4755.46353.1123.65451L10.9999 4ZM14.9999 4l-.5878.30902.1123-.65451-.4756-.46353.6572-.09549.2939-.59549.2939.59549.6571.09549-.4755.46353.1123.65451L14.9999 4ZM18.9999 4l-.5878.30902.1123-.65451-.4756-.46353.6572-.09549.2939-.59549.2939.59549.6571.09549-.4755.46353.1123.65451L18.9999 4Z" }),
      /* @__PURE__ */ jsx("path", { d: "m18.9999 4-.5878.30902.1123-.65451-.4756-.46353.6572-.09549.2939-.59549.2939.59549.6571.09549-.4755.46353.1123.65451L18.9999 4ZM20.9999 7l-.5878.30902.1123-.65451-.4756-.46353.6572-.09549.2939-.59549.2939.59549.6571.09549-.4755.46353.1123.65451L20.9999 7ZM4.99988 7l-.58778.30902.11226-.65451-.47553-.46353.65716-.09549L4.99988 5.5l.2939.59549.65716.09549-.47553.46353.11226.65451L4.99988 7ZM8.99988 7l-.58778.30902.11226-.65451-.47553-.46353.65716-.09549L8.99988 5.5l.2939.59549.65716.09549-.47553.46353.11226.65451L8.99988 7ZM12.9999 7l-.5878.30902.1123-.65451-.4756-.46353.6572-.09549.2939-.59549.2939.59549.6571.09549-.4755.46353.1123.65451L12.9999 7ZM16.9999 7l-.5878.30902.1123-.65451-.4756-.46353.6572-.09549.2939-.59549.2939.59549.6571.09549-.4755.46353.1123.65451L16.9999 7ZM22.9999 4l-.5878.30902.1123-.65451-.4756-.46353.6572-.09549.2939-.59549.2939.59549.6571.09549-.4755.46353.1123.65451L22.9999 4ZM2.99988 10l-.58778.309.11226-.65449-.47553-.46353.65716-.09549L2.99988 8.5l.2939.59549.65716.09549-.47553.46353.11226.65449L2.99988 10ZM6.99988 10l-.58778.309.11226-.65449-.47553-.46353.65716-.09549L6.99988 8.5l.2939.59549.65716.09549-.47553.46353.11226.65449L6.99988 10ZM10.9999 10l-.5878.309.1123-.65449-.4756-.46353.6572-.09549.2939-.59549.2939.59549.6571.09549-.4755.46353.1123.65449-.5878-.309ZM14.9999 10l-.5878.309.1123-.65449-.4756-.46353.6572-.09549.2939-.59549.2939.59549.6571.09549-.4755.46353.1123.65449-.5878-.309ZM18.9999 10l-.5878.309.1123-.65449-.4756-.46353.6572-.09549.2939-.59549.2939.59549.6571.09549-.4755.46353.1123.65449-.5878-.309Z" }),
      /* @__PURE__ */ jsx("path", { d: "m18.9999 10-.5878.309.1123-.65449-.4756-.46353.6572-.09549.2939-.59549.2939.59549.6571.09549-.4755.46353.1123.65449-.5878-.309ZM20.9999 13l-.5878.309.1123-.6545-.4756-.4635.6572-.0955.2939-.5955.2939.5955.6571.0955-.4755.4635.1123.6545-.5878-.309ZM4.99988 13l-.58778.309.11226-.6545-.47553-.4635.65716-.0955.29389-.5955.2939.5955.65716.0955-.47553.4635.11226.6545L4.99988 13ZM8.99988 13l-.58778.309.11226-.6545-.47553-.4635.65716-.0955.29389-.5955.2939.5955.65716.0955-.47553.4635.11226.6545L8.99988 13ZM12.9999 13l-.5878.309.1123-.6545-.4756-.4635.6572-.0955.2939-.5955.2939.5955.6571.0955-.4755.4635.1123.6545-.5878-.309ZM16.9999 13l-.5878.309.1123-.6545-.4756-.4635.6572-.0955.2939-.5955.2939.5955.6571.0955-.4755.4635.1123.6545-.5878-.309ZM22.9999 10l-.5878.309.1123-.65449-.4756-.46353.6572-.09549.2939-.59549.2939.59549.6571.09549-.4755.46353.1123.65449-.5878-.309ZM2.99988 16l-.58778.309.11226-.6545-.47553-.4635.65716-.0955.29389-.5955.2939.5955.65716.0955-.47553.4635.11226.6545L2.99988 16ZM6.99988 16l-.58778.309.11226-.6545-.47553-.4635.65716-.0955.29389-.5955.2939.5955.65716.0955-.47553.4635.11226.6545L6.99988 16ZM10.9999 16l-.5878.309.1123-.6545-.4756-.4635.6572-.0955.2939-.5955.2939.5955.6571.0955-.4755.4635.1123.6545-.5878-.309ZM14.9999 16l-.5878.309.1123-.6545-.4756-.4635.6572-.0955.2939-.5955.2939.5955.6571.0955-.4755.4635.1123.6545-.5878-.309ZM18.9999 16l-.5878.309.1123-.6545-.4756-.4635.6572-.0955.2939-.5955.2939.5955.6571.0955-.4755.4635.1123.6545-.5878-.309Z" }),
      /* @__PURE__ */ jsx("path", { d: "m18.9999 16-.5878.309.1123-.6545-.4756-.4635.6572-.0955.2939-.5955.2939.5955.6571.0955-.4755.4635.1123.6545-.5878-.309ZM22.9999 16l-.5878.309.1123-.6545-.4756-.4635.6572-.0955.2939-.5955.2939.5955.6571.0955-.4755.4635.1123.6545-.5878-.309Z" })
    ] }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});
const Cs = createIcon({
  displayName: "Cs",
  viewBox: "0 0 48 32",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "red", y: "16", width: "48", height: "16", fill: "#E94B35" }),
    /* @__PURE__ */ jsx("rect", { id: "white", width: "48", height: "16", fill: "white" }),
    /* @__PURE__ */ jsx("path", { id: "blue", fillRule: "evenodd", clipRule: "evenodd", d: "M0 0L24 16L0 32V0Z", fill: "#227FBB" })
  ] })
});
const Bg = createIcon({
  displayName: "Bg",
  viewBox: "0 0 48 32",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "white", width: "48", height: "11", fill: "white" }),
    /* @__PURE__ */ jsx("rect", { id: "green", y: "11", width: "48", height: "10", fill: "#1AAF5D" }),
    /* @__PURE__ */ jsx("rect", { id: "red", y: "21", width: "48", height: "11", fill: "#E94B35" })
  ] })
});
const Hu = createIcon({
  displayName: "Hu",
  viewBox: "0 0 48 32",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "green", y: "21", width: "48", height: "11", fill: "#1AAF5D" }),
    /* @__PURE__ */ jsx("rect", { id: "white", y: "11", width: "48", height: "10", fill: "white" }),
    /* @__PURE__ */ jsx("rect", { id: "red", width: "48", height: "11", fill: "#E94B35" })
  ] })
});
const Md = createIcon({
  displayName: "Md",
  viewBox: "0 0 48 32",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "red", x: "32", width: "16", height: "32", fill: "#E94B35" }),
    /* @__PURE__ */ jsx("rect", { id: "blue", width: "16", height: "32", fill: "#227FBB" }),
    /* @__PURE__ */ jsx("rect", { id: "yellow", x: "16", width: "16", height: "32", fill: "#F2C500" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Combined Shape",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23 11L22 12L20 11L19.6205 10.241C19.5724 10.1448 19.5092 10.0571 19.4332 9.98106C19.0426 9.59053 18.4095 9.59053 18.0189 9.98106L17 11V23L23 19L20 24L24 26L28 24L25 19L31 23V11L29.9811 9.98106C29.9051 9.90506 29.8173 9.84181 29.7212 9.79374C29.2272 9.54675 28.6265 9.74697 28.3795 10.241L28 11L26 12L25 11V9.61805C25.3069 9.34339 25.5 8.94425 25.5 8.5C25.5 7.67157 24.8284 7 24 7C23.1716 7 22.5 7.67157 22.5 8.5C22.5 8.94425 22.6931 9.34339 23 9.61805V11Z",
        fill: "#AF7D61"
      }
    ),
    /* @__PURE__ */ jsx("path", { id: "Rectangle 41", fillRule: "evenodd", clipRule: "evenodd", d: "M20 12H28V19L24 21L20 19V12Z", fill: "#2C97DE" }),
    /* @__PURE__ */ jsx("path", { id: "Rectangle 41_2", fillRule: "evenodd", clipRule: "evenodd", d: "M20 12H28V16H20V12Z", fill: "#E94B35" }),
    /* @__PURE__ */ jsx("path", { id: "Rectangle 40", fillRule: "evenodd", clipRule: "evenodd", d: "M23 16H25V19L24 20L23 19V16Z", fill: "#F2C500" }),
    /* @__PURE__ */ jsx("circle", { id: "Oval 42", cx: "24", cy: "14", r: "1", fill: "#F2C500" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Combined Shape_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.45 14C26.2184 15.1411 25.2095 16 24 16C22.7905 16 21.7816 15.1411 21.55 14C21.5172 14.1616 21.5 14.3288 21.5 14.5C21.5 15.8807 22.6193 17 24 17C25.3807 17 26.5 15.8807 26.5 14.5C26.5 14.3288 26.4828 14.1616 26.45 14Z",
        fill: "#F2C500"
      }
    )
  ] })
});
const Tr = createIcon({
  displayName: "Tr",
  viewBox: "0 0 48 32",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { x: "1", y: "1", width: "48", height: "32", fill: "#FF1A26", stroke: "#F3F6F9" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.6209 9.97068C28.805 9.66635 27.9219 9.5 27 9.5C22.8579 9.5 19.5 12.8579 19.5 17C19.5 21.1421 22.8579 24.5 27 24.5C27.9219 24.5 28.805 24.3336 29.6209 24.0293C28.0807 25.2625 26.1265 26 24 26C19.0294 26 15 21.9706 15 17C15 12.0294 19.0294 8 24 8C26.1265 8 28.0807 8.7375 29.6209 9.97068Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M32.5376 18.2275L31.1942 20.7364L30.6918 17.9351L27.8905 17.4327L30.3994 16.0893L30.0116 13.2699L32.0645 15.2409L34.6261 14.0008L33.386 16.5623L35.357 18.6153L32.5376 18.2275Z",
        fill: "white"
      }
    )
  ] })
});
const Sa = createIcon({
  displayName: "Sa",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsx("svg", { width: "50", height: "34", viewBox: "0 0 50 34", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsxs("g", { children: [
      /* @__PURE__ */ jsx("rect", { id: "BG", x: "1", y: "1", width: "48", height: "32", fill: "#00AE82" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "white",
          fillRule: "evenodd",
          d: "M22.8 9H24a1 1 0 1 1 0 2 1 1 0 0 0-1 1.2c.1.4.6.7 1 .6h.1a.3.3 0 0 1 .4.5l-.2.3a1 1 0 0 0 0 1l.2.4a.4.4 0 0 1-.5.5H24a.6.6 0 0 0-.9.5c0 .6.4 1 1 1s1 .4 1 1v.9a.3.3 0 0 1-.5.1l-.2-.4a.5.5 0 0 0-.8-.1c-.3.3-.7.3-1 0l-.8-.8a.8.8 0 0 0-1.1 0c-.4.3-.4.8-.2 1.1l.2.3a.4.4 0 0 1-.4.5l-.5-.2a1 1 0 0 1-.7-.9v-9a.5.5 0 0 1 1 0v5.8a.3.3 0 0 0 .5.2l.3-.3.3-.5.8-4.9c0-.4.5-.8 1-.8Zm12.4 0c.4 0 .9.4 1 .8l.7 4.9c0 .2.2.4.3.5l.3.3a.3.3 0 0 0 .5-.2V9.5a.5.5 0 0 1 1 0v9c0 .4-.3.8-.7 1l-.5.1a.4.4 0 0 1-.4-.5l.2-.3c.2-.3.2-.8-.2-1.1a.8.8 0 0 0-1.1 0l-.8.8c-.3.3-.7.3-1 0a.5.5 0 0 0-.8.1l-.2.4a.3.3 0 0 1-.5-.1V18c0-.6.4-1 1-1s1-.4 1-1a.6.6 0 0 0-.9-.6l-.1.1a.4.4 0 0 1-.5-.5l.2-.4a1 1 0 0 0 0-1l-.2-.3a.3.3 0 0 1 .4-.5h.1a.8.8 0 0 0 1-.8c0-.6-.4-1-1-1a1 1 0 1 1 0-2h1.2Zm-7 10.7c.4 0 .9-.4 1-.9l.7-4.8.3-.6.3-.2a.3.3 0 0 1 .5.2v5.8a.5.5 0 0 0 1 0v-9a1 1 0 0 0-.7-1l-.5-.2a.4.4 0 0 0-.4.6l.2.2c.2.4.2.9-.2 1.2-.3.2-.8.2-1.1 0l-.8-.9a.7.7 0 0 0-1 0 .5.5 0 0 1-.8 0l-.2-.4a.3.3 0 0 0-.5 0v1c0 .5.4 1 1 1s1 .4 1 1a.6.6 0 0 1-.9.5H27a.4.4 0 0 0-.5.4l.2.5c.2.3.2.7 0 1l-.2.2a.3.3 0 0 0 .4.6h.1a.8.8 0 0 1 1 .7c0 .6-.4 1-1 1a1 1 0 1 0 0 2h1.2Zm-13.4 0a1 1 0 0 1-1-.9l-.8-4v-.3l-.5-.8a.3.3 0 0 0-.5 0v5.5a.5.5 0 0 1-1 0v-9c0-.5.3-.8.7-1l.5-.2a.4.4 0 0 1 .4.6l-.2.2c-.2.4-.2.9.2 1.2.3.2.8.2 1.1 0l.8-.9c.3-.2.7-.2 1 0 .3.3.7.3 1 0l.5-.4a.6.6 0 0 1 1 .4v.6c0 .5-.4 1-1 1h-1a1 1 0 0 0-1 1 .7.7 0 0 0 1 .6l.7-.2a.3.3 0 0 1 .3.5l-.5.5a1 1 0 0 0-.2 1.1l.3 1a.5.5 0 0 1-.6.6h-.5a.4.4 0 0 0-.5.3c0 .3.2.6.5.6H17a1 1 0 1 1 0 2h-2.2ZM33 24H12.7a.3.3 0 0 0-.2.5l.6.6a3 3 0 0 0 2.1.9H33c0 .6.4 1 1 1h2.5c.8 0 1.5-.7 1.5-1.5v-1c0-.3-.2-.5-.5-.5h-3v-.5a1 1 0 0 0-.4-.8l-.3-.2a.5.5 0 0 0-.8.4V24Z",
          clipRule: "evenodd"
        }
      )
    ] }),
    /* @__PURE__ */ jsx("rect", { id: "Outline", x: "0.5", y: "0.5", width: "49", height: "33", stroke: "#F1F4F8" })
  ] }) })
});
const Om = createIcon({
  displayName: "Om",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs("svg", { width: "50", height: "34", viewBox: "0 0 50 34", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx("rect", { x: "1", y: "1", width: "48", height: "32", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("rect", { x: "17", y: "23", width: "32", height: "10", fill: "#00AE82" }),
    /* @__PURE__ */ jsx("rect", { x: "17", y: "1", width: "32", height: "10", fill: "white" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M4.05754 3.73279C6.78799 8.92592 10.171 12.9855 14.207 15.9052C14.4308 16.0671 14.7434 16.0169 14.9052 15.7932C15.0671 15.5694 15.0169 15.2568 14.7932 15.095C10.8879 12.2699 7.60419 8.32946 4.94266 3.26741C4.81415 3.023 4.51183 2.92903 4.26741 3.05754C4.023 3.18605 3.92903 3.48837 4.05754 3.73279Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M13.9426 3.73279C11.2121 8.92592 7.82915 12.9855 3.7931 15.9052C3.56936 16.0671 3.25678 16.0169 3.09492 15.7932C2.93307 15.5694 2.98324 15.2568 3.20698 15.095C7.11227 12.2699 10.3959 8.32946 13.0575 3.26741C13.186 3.023 13.4883 2.92903 13.7327 3.05754C13.9771 3.18605 14.0711 3.48837 13.9426 3.73279Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.5 8H13.5C13.7761 8 14 8.22386 14 8.5V9.5C14 9.77614 13.7761 10 13.5 10H3.5C3.22386 10 3 9.77614 3 9.5V8.5C3 8.22386 3.22386 8 3.5 8Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 7.00009L8.5 6.00009V4.00391H9.5V6.00009L10 7.00009V12.0001H4.75C4.33579 12.0001 4 11.6643 4 11.2501C4 10.8359 4.33579 10.5001 4.75 10.5001H8V7.00009Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx("ellipse", { cx: "9", cy: "4", rx: "1", ry: "0.5", fill: "white" }),
    /* @__PURE__ */ jsx("rect", { x: "0.5", y: "0.5", width: "49", height: "33", stroke: "#F3F6F9" })
  ] })
});
const Un = createIcon({
  displayName: "Un",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { stroke: "#F1F4F8", d: "M.5.5h49v33H.5z" }),
    /* @__PURE__ */ jsx("path", { fill: "#3D91FF", fillRule: "evenodd", d: "M1 1h48v32H1V1Z", clipRule: "evenodd" }),
    /* @__PURE__ */ jsxs("g", { fill: "#fff", fillRule: "evenodd", clipRule: "evenodd", children: [
      /* @__PURE__ */ jsx("path", { d: "M12 16c0 6.1408 4.2918 11.408 10.2133 12.7008.5396.1178.8815.6508.7637 1.1903-.1178.5396-.6507.8815-1.1903.7637C14.9513 29.1625 10 23.0859 10 16c0-4.4896 1.9855-8.6577 5.3568-11.4899.4228-.3552 1.0536-.3004 1.4089.1224.3552.423.3004 1.0537-.1225 1.409C13.7196 8.4975 12 12.1075 12 16Zm26 0c0-3.8925-1.7196-7.5024-4.6432-9.9585-.4229-.3553-.4777-.986-.1225-1.409.3553-.4228.9861-.4776 1.4089-.1224C38.0145 7.3423 40 11.5104 40 16c0 7.0859-4.9513 13.1625-11.7867 14.6548-.5396.1178-1.0725-.2241-1.1903-.7637-.1178-.5395.2241-1.0725.7637-1.1903C33.7082 27.408 38 22.1408 38 16Z" }),
      /* @__PURE__ */ jsx("path", { d: "M14.3393 17.2534a.2.2 0 0 1 .2465-.1945l1.5044.3596a.2.2 0 0 0 .2252-.1047l.5643-1.1222a.1999.1999 0 0 1 .2036-.1085l1.0606.1333a.2002.2002 0 0 1 .1622.1279l1.3518 3.5859a.2.2 0 0 1-.1872.2706h-1.8202a.2002.2002 0 0 1-.0838-.0184l-3.1112-1.4352a.2.2 0 0 1-.1162-.1816v-1.3122ZM19.6324 14.075a.2004.2004 0 0 1 .0764-.1032l1.2361-.858a.2002.2002 0 0 1 .1529-.0319l1.4263.2819a.2004.2004 0 0 0 .0908-.0031l.9596-.2588a.2.2 0 0 1 .2158.0783l.2298.3277a.2013.2013 0 0 1-.0232.2584c-.1873.1862-.5258.5286-.5172.5623.0095.0373.5891.7922.8175 1.0888a.1997.1997 0 0 1 .0033.2393l-.3477.4798a.2002.2002 0 0 1-.249.0627l-.7047-.3406a.2.2 0 0 0-.2421.0537l-.5528.6787a.2.2 0 0 1-.286.0248l-1.6132-1.3973a.2002.2002 0 0 0-.2166-.0296l-.5426.2569c-.1582.075-.3295-.0752-.276-.2419l.3626-1.1289ZM26.2141 14.1221a.1992.1992 0 0 0-.0389-.0912l-.4724-.6172c-.1107-.1447.0139-.35.1934-.3186l.8944.1567a.2.2 0 0 0 .1639-.0444l.9228-.7827a.1998.1998 0 0 1 .1928-.0371l1.0657.3565 1.7769.8571a.2.2 0 0 1 .0681.3065l-.9002 1.1037a.2002.2002 0 0 0-.0046.247l.5924.7841a.2.2 0 0 1-.0535.2901l-1.3693.8564a.2002.2002 0 0 0-.0921.1969l.5421 3.9221a.2.2 0 0 1-.0615.1735l-1.3119 1.2262a.1998.1998 0 0 1-.24.025l-1.1247-.68a.1998.1998 0 0 1-.088-.1134l-.3358-1.1131a.2.2 0 0 0-.182-.142l-1.6913-.0805a.1998.1998 0 0 1-.1626-.0979l-.4496-.7596a.1999.1999 0 0 1 .021-.2329l.8943-1.0307a.1945.1945 0 0 0 .0204-.0282l1.4719-2.4538a.2004.2004 0 0 0 .0262-.1332l-.2679-1.7453ZM29.1032 8.2456a.2.2 0 0 1 .1615-.2761l.9833-.1134a.2.2 0 0 1 .1874.0848l1.1304 1.6328 1.4899 1.7944a.2.2 0 0 1-.0407.2927l-.4772.3274a.2.2 0 0 1-.2246.0011l-2.2309-1.4985a.1992.1992 0 0 1-.0728-.0885l-.9063-2.1567Z" }),
      /* @__PURE__ */ jsx("path", { d: "M25 27c6.0751 0 11-4.9249 11-11S31.0751 5 25 5 14 9.925 14 16s4.9249 11 11 11Zm0-.5c5.799 0 10.5-4.701 10.5-10.5S30.799 5.5 25 5.5 14.5 10.201 14.5 16 19.201 26.5 25 26.5Z" }),
      /* @__PURE__ */ jsx("path", { d: "M25 24c4.4183 0 8-3.5817 8-8s-3.5817-8-8-8-8 3.5817-8 8 3.5817 8 8 8Zm0-.5c4.1421 0 7.5-3.3579 7.5-7.5S29.1421 8.5 25 8.5s-7.5 3.3579-7.5 7.5 3.3579 7.5 7.5 7.5Z" }),
      /* @__PURE__ */ jsx("path", { d: "M25 21c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5Zm0-.5c2.4853 0 4.5-2.0147 4.5-4.5s-2.0147-4.5-4.5-4.5-4.5 2.0147-4.5 4.5 2.0147 4.5 4.5 4.5Z" })
    ] })
  ] })
});
const Za = createIcon({
  displayName: "Za",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs("svg", { width: "50", height: "34", viewBox: "0 0 50 34", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 1V33H49V1H1Z", fill: "white" }),
    /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 1H1V33H6L28.7807 22H49V12H28.7807L6 1Z", fill: "#00AE82" }),
    /* @__PURE__ */ jsx("path", { d: "M10.5996 1L29.2384 10H49.0001V1L10.5996 1Z", fill: "#FF1A26" }),
    /* @__PURE__ */ jsx("path", { d: "M10.5996 33L29.2384 24H49.0001V33H10.5996Z", fill: "#0070B8" }),
    /* @__PURE__ */ jsx("path", { d: "M1 6.79004L22.6971 17.0004L1 27.2108L1 6.79004Z", fill: "#FBB43A" }),
    /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 9V25L18 17L1 9Z", fill: "#0B0F14" }),
    /* @__PURE__ */ jsx("rect", { x: "0.5", y: "0.5", width: "49", height: "33", stroke: "#F3F6F9" })
  ] })
});
const Qa = createIcon({
  displayName: "Qa",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { x: "0.5", y: "0.5", width: "49", height: "33", stroke: "#F1F4F8" }),
    /* @__PURE__ */ jsx("rect", { x: "1", y: "1", width: "48", height: "32", fill: "white" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M49 1V33H23.706H17.5L23.3235 31.2222L17.5 29.4444L23.3235 27.6667L17.5 25.8889L23.3235 24.1111L17.5 22.3333L23.3235 20.5556L17.5 18.7778L23.3235 17L17.5 15.2222C17.5 15.2222 23.3236 13.4445 23.3235 13.4444L17.5 11.6667L23.3235 9.88889L17.5 8.11111L23.3235 6.33333L17.5 4.55556L23.3235 2.77778L17.5 1H23.5882H49Z",
        fill: "#AA3751"
      }
    )
  ] })
});
const Jp = createIcon({
  displayName: "Jp",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { x: "0.5", y: "0.5", width: "49", height: "33", stroke: "#F1F4F8" }),
    /* @__PURE__ */ jsx("rect", { x: "1", y: "1", width: "48", height: "32", fill: "white" }),
    /* @__PURE__ */ jsx("circle", { cx: "25", cy: "17", r: "10", fill: "#E6000C" })
  ] })
});
const __variableDynamicImportRuntimeHelper = (glob, path, segs) => {
  const v = glob[path];
  if (v) {
    return typeof v === "function" ? v() : Promise.resolve(v);
  }
  return new Promise((_, reject) => {
    (typeof queueMicrotask === "function" ? queueMicrotask : setTimeout)(
      reject.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + path + (path.split("/").length !== segs ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
const COUNTRIES = {
  ad: { id: "ad", name: "Andorra" },
  ae: { id: "ae", name: "United Arab Emirates" },
  af: { id: "af", name: "Afghanistan" },
  ag: { id: "ag", name: "Antigua and Barbuda" },
  al: { id: "al", name: "Albania" },
  am: { id: "am", name: "Armenia" },
  ana: { id: "ana", name: "Anac" },
  ao: { id: "ao", name: "Angola" },
  aq: { id: "aq", name: "Antarctica" },
  ar: { id: "ar", name: "Argentina" },
  as: { id: "as", name: "American Samoa" },
  at: { id: "at", name: "Austria" },
  au: { id: "au", name: "Australia" },
  aw: { id: "aw", name: "Aruba" },
  ax: { id: "ax", name: "Åland Islands" },
  az: { id: "az", name: "Azerbaijan" },
  ba: { id: "ba", name: "Bosnia and Herzegovina" },
  bb: { id: "bb", name: "Barbados" },
  bd: { id: "bd", name: "Bangladesh" },
  be: { id: "be", name: "Belgium" },
  bf: { id: "bf", name: "Burkina Faso" },
  bg: { id: "bg", name: "Bulgaria" },
  bh: { id: "bh", name: "Bahrain" },
  bi: { id: "bi", name: "Burundi" },
  bj: { id: "bj", name: "Benin" },
  bl: { id: "bl", name: "Saint Barthélemy" },
  bm: { id: "bm", name: "Bermuda" },
  bn: { id: "bn", name: "Brunei" },
  bo: { id: "bo", name: "Bolivia" },
  bq: { id: "bq", name: "Caribbean Netherlands" },
  br: { id: "br", name: "Brazil" },
  bs: { id: "bs", name: "Bahamas" },
  bt: { id: "bt", name: "Bhutan" },
  bv: { id: "bv", name: "Bouvet Island" },
  bw: { id: "bw", name: "Botswana" },
  by: { id: "by", name: "Belarus" },
  bz: { id: "bz", name: "Belize" },
  ca: { id: "ca", name: "Canada" },
  cc: { id: "cc", name: "Cocos (Keeling) Islands" },
  cd: { id: "cd", name: "Democratic Republic of the Congo" },
  cefta: { id: "cefta", name: "Central European Free Trade Agreement" },
  cf: { id: "cf", name: "Central African Republic" },
  cg: { id: "cg", name: "Republic of the Congo" },
  ch: { id: "ch", name: "Switzerland" },
  ci: { id: "ci", name: "Côte d'Ivoire" },
  ck: { id: "ck", name: "Cook Islands" },
  cl: { id: "cl", name: "Chile" },
  cm: { id: "cm", name: "Cameroon" },
  cn: { id: "cn", name: "China" },
  co: { id: "co", name: "Colombia" },
  cp: { id: "cp", name: "Clipperton Island" },
  cr: { id: "cr", name: "Costa Rica" },
  cu: { id: "cu", name: "Cuba" },
  cv: { id: "cv", name: "Cape Verde" },
  cw: { id: "cw", name: "Curaçao" },
  cx: { id: "cx", name: "Christmas Island" },
  cy: { id: "cy", name: "Cyprus" },
  cz: { id: "cz", name: "Czech Republic" },
  de: { id: "de", name: "Germany" },
  dg: { id: "dg", name: "Diego Garcia" },
  dj: { id: "dj", name: "Djibouti" },
  dk: { id: "dk", name: "Denmark" },
  dm: { id: "dm", name: "Dominica" },
  do: { id: "do", name: "Dominican Republic" },
  dz: { id: "dz", name: "Algeria" },
  ea: { id: "ea", name: "Ceuta & Melilla" },
  ec: { id: "ec", name: "Ecuador" },
  ee: { id: "ee", name: "Estonia" },
  eg: { id: "eg", name: "Egypt" },
  eh: { id: "eh", name: "Western Sahara" },
  er: { id: "er", name: "Eritrea" },
  "es-ct": { id: "es-ct", name: "Catalonia" },
  "es-ga": { id: "es-ga", name: "Galicia" },
  es: { id: "es", name: "Spain" },
  et: { id: "et", name: "Ethiopia" },
  eu: { id: "eu", name: "European Union" },
  fi: { id: "fi", name: "Finland" },
  fj: { id: "fj", name: "Fiji" },
  fk: { id: "fk", name: "Falkland Islands" },
  fm: { id: "fm", name: "Micronesia" },
  fo: { id: "fo", name: "Faroe Islands" },
  fr: { id: "fr", name: "France" },
  ga: { id: "ga", name: "Gabon" },
  "gb-eng": { id: "gb-eng", name: "England" },
  "gb-nir": { id: "gb-nir", name: "Northern Ireland" },
  "gb-sct": { id: "gb-sct", name: "Scotland" },
  "gb-wls": { id: "gb-wls", name: "Wales" },
  gb: { id: "gb", name: "United Kingdom" },
  gd: { id: "gd", name: "Grenada" },
  ge: { id: "ge", name: "Georgia" },
  gf: { id: "gf", name: "French Guiana" },
  gg: { id: "gg", name: "Guernsey" },
  gh: { id: "gh", name: "Ghana" },
  gi: { id: "gi", name: "Gibraltar" },
  gl: { id: "gl", name: "Greenland" },
  gm: { id: "gm", name: "Gambia" },
  gn: { id: "gn", name: "Guinea" },
  gp: { id: "gp", name: "Guadeloupe" },
  gq: { id: "gq", name: "Equatorial Guinea" },
  gr: { id: "gr", name: "Greece" },
  gs: { id: "gs", name: "South Georgia & South Sandwich Islands" },
  gt: { id: "gt", name: "Guatemala" },
  gu: { id: "gu", name: "Guam" },
  gw: { id: "gw", name: "Guinea-Bissau" },
  gy: { id: "gy", name: "Guyana" },
  hk: { id: "hk", name: "Hong Kong" },
  hm: { id: "hm", name: "Heard & McDonald Islands" },
  hn: { id: "hn", name: "Honduras" },
  hr: { id: "hr", name: "Croatia" },
  ht: { id: "ht", name: "Haiti" },
  hu: { id: "hu", name: "Hungary" },
  ic: { id: "ic", name: "Canary Islands" },
  id: { id: "id", name: "Indonesia" },
  ie: { id: "ie", name: "Ireland" },
  il: { id: "il", name: "Israel" },
  im: { id: "im", name: "Isle of Man" },
  "in": { id: "in", name: "India" },
  io: { id: "io", name: "British Indian Ocean Territory" },
  iq: { id: "iq", name: "Iraq" },
  ir: { id: "ir", name: "Iran" },
  is: { id: "is", name: "Iceland" },
  it: { id: "it", name: "Italy" },
  je: { id: "je", name: "Jersey" },
  jm: { id: "jm", name: "Jamaica" },
  jo: { id: "jo", name: "Jordan" },
  jp: { id: "jp", name: "Japan" },
  ke: { id: "ke", name: "Kenya" },
  kg: { id: "kg", name: "Kyrgyzstan" },
  kh: { id: "kh", name: "Cambodia" },
  ki: { id: "ki", name: "Kiribati" },
  km: { id: "km", name: "Comoros" },
  kn: { id: "kn", name: "Saint Kitts and Nevis" },
  kp: { id: "kp", name: "North Korea" },
  kr: { id: "kr", name: "South Korea" },
  kw: { id: "kw", name: "Kuwait" },
  ky: { id: "ky", name: "Cayman Islands" },
  kz: { id: "kz", name: "Kazakhstan" },
  la: { id: "la", name: "Laos" },
  lb: { id: "lb", name: "Lebanon" },
  lc: { id: "lc", name: "Saint Lucia" },
  li: { id: "li", name: "Liechtenstein" },
  lk: { id: "lk", name: "Sri Lanka" },
  lr: { id: "lr", name: "Liberia" },
  ls: { id: "ls", name: "Lesotho" },
  lt: { id: "lt", name: "Lithuania" },
  lu: { id: "lu", name: "Luxembourg" },
  lv: { id: "lv", name: "Latvia" },
  ly: { id: "ly", name: "Libya" },
  ma: { id: "ma", name: "Morocco" },
  mc: { id: "mc", name: "Monaco" },
  md: { id: "md", name: "Moldova" },
  me: { id: "me", name: "Montenegro" },
  mf: { id: "mf", name: "Saint Martin" },
  mg: { id: "mg", name: "Madagascar" },
  mh: { id: "mh", name: "Marshall Islands" },
  mk: { id: "mk", name: "North Macedonia" },
  ml: { id: "ml", name: "Mali" },
  mm: { id: "mm", name: "Myanmar" },
  mn: { id: "mn", name: "Mongolia" },
  mo: { id: "mo", name: "Macau" },
  mp: { id: "mp", name: "Northern Mariana Islands" },
  mq: { id: "mq", name: "Martinique" },
  mr: { id: "mr", name: "Mauritania" },
  ms: { id: "ms", name: "Montserrat" },
  mt: { id: "mt", name: "Malta" },
  mu: { id: "mu", name: "Mauritius" },
  mv: { id: "mv", name: "Maldives" },
  mw: { id: "mw", name: "Malawi" },
  mx: { id: "mx", name: "Mexico" },
  my: { id: "my", name: "Malaysia" },
  mz: { id: "mz", name: "Mozambique" },
  na: { id: "na", name: "Namibia" },
  nc: { id: "nc", name: "New Caledonia" },
  ne: { id: "ne", name: "Niger" },
  nf: { id: "nf", name: "Norfolk Island" },
  ng: { id: "ng", name: "Nigeria" },
  ni: { id: "ni", name: "Nicaragua" },
  nl: { id: "nl", name: "Netherlands" },
  no: { id: "no", name: "Norway" },
  np: { id: "np", name: "Nepal" },
  nr: { id: "nr", name: "Nauru" },
  nu: { id: "nu", name: "Niue" },
  nz: { id: "nz", name: "New Zealand" },
  om: { id: "om", name: "Oman" },
  pa: { id: "pa", name: "Panama" },
  pe: { id: "pe", name: "Peru" },
  pf: { id: "pf", name: "French Polynesia" },
  pg: { id: "pg", name: "Papua New Guinea" },
  ph: { id: "ph", name: "Philippines" },
  pk: { id: "pk", name: "Pakistan" },
  pl: { id: "pl", name: "Poland" },
  pm: { id: "pm", name: "Saint Pierre & Miquelon" },
  pn: { id: "pn", name: "Pitcairn Islands" },
  pr: { id: "pr", name: "Puerto Rico" },
  ps: { id: "ps", name: "Palestine" },
  pt: { id: "pt", name: "Portugal" },
  pw: { id: "pw", name: "Palau" },
  py: { id: "py", name: "Paraguay" },
  qa: { id: "qa", name: "Qatar" },
  re: { id: "re", name: "Réunion" },
  ro: { id: "ro", name: "Romania" },
  rs: { id: "rs", name: "Serbia" },
  ru: { id: "ru", name: "Russia" },
  rw: { id: "rw", name: "Rwanda" },
  sa: { id: "sa", name: "Saudi Arabia" },
  sb: { id: "sb", name: "Solomon Islands" },
  sc: { id: "sc", name: "Seychelles" },
  sd: { id: "sd", name: "Sudan" },
  se: { id: "se", name: "Sweden" },
  sg: { id: "sg", name: "Singapore" },
  "sh-ac": { id: "sh-ac", name: "Ascension Island" },
  sh: { id: "sh", name: "Saint Helena" },
  si: { id: "si", name: "Slovenia" },
  sj: { id: "sj", name: "Svalbard & Jan Mayen" },
  sk: { id: "sk", name: "Slovakia" },
  sl: { id: "sl", name: "Sierra Leone" },
  sm: { id: "sm", name: "San Marino" },
  sn: { id: "sn", name: "Senegal" },
  so: { id: "so", name: "Somalia" },
  sr: { id: "sr", name: "Suriname" },
  ss: { id: "ss", name: "South Sudan" },
  st: { id: "st", name: "São Tomé & Príncipe" },
  sv: { id: "sv", name: "El Salvador" },
  sx: { id: "sx", name: "Sint Maarten" },
  sy: { id: "sy", name: "Syria" },
  sz: { id: "sz", name: "Eswatini" },
  ta: { id: "ta", name: "Tristan da Cunha" },
  tc: { id: "tc", name: "Turks & Caicos Islands" },
  td: { id: "td", name: "Chad" },
  tf: { id: "tf", name: "French Southern Territories" },
  tg: { id: "tg", name: "Togo" },
  th: { id: "th", name: "Thailand" },
  tj: { id: "tj", name: "Tajikistan" },
  tk: { id: "tk", name: "Tokelau" },
  tl: { id: "tl", name: "Timor-Leste" },
  tm: { id: "tm", name: "Turkmenistan" },
  tn: { id: "tn", name: "Tunisia" },
  to: { id: "to", name: "Tonga" },
  tr: { id: "tr", name: "Turkey" },
  tt: { id: "tt", name: "Trinidad & Tobago" },
  tv: { id: "tv", name: "Tuvalu" },
  tw: { id: "tw", name: "Taiwan" },
  tz: { id: "tz", name: "Tanzania" },
  ua: { id: "ua", name: "Ukraine" },
  ug: { id: "ug", name: "Uganda" },
  um: { id: "um", name: "U.S. Outlying Islands" },
  un: { id: "un", name: "United Nations" },
  us: { id: "us", name: "United States" },
  uy: { id: "uy", name: "Uruguay" },
  uz: { id: "uz", name: "Uzbekistan" },
  va: { id: "va", name: "Vatican City" },
  vc: { id: "vc", name: "Saint Vincent & Grenadines" },
  ve: { id: "ve", name: "Venezuela" },
  vg: { id: "vg", name: "British Virgin Islands" },
  vi: { id: "vi", name: "U.S. Virgin Islands" },
  vn: { id: "vn", name: "Vietnam" },
  vu: { id: "vu", name: "Vanuatu" },
  wf: { id: "wf", name: "Wallis & Futuna" },
  ws: { id: "ws", name: "Samoa" },
  xk: { id: "xk", name: "Kosovo" },
  ye: { id: "ye", name: "Yemen" },
  yt: { id: "yt", name: "Mayotte" },
  za: { id: "za", name: "South Africa" },
  zm: { id: "zm", name: "Zambia" },
  zw: { id: "zw", name: "Zimbabwe" },
  world: { id: "world", name: "World" },
  xx: { id: "xx", name: "Unknown" }
};
const UNKNOWN_COUNTRY_CODE = "xx";
function isCountryFlagCode(code) {
  return code in COUNTRIES;
}
const FLAG_STYLES = {
  l: { w: "42px", h: "32px" },
  m: { w: "32px", h: "24px" },
  s: { w: "26px", h: "20px" },
  xs: { w: "20px", h: "15px" }
};
const MISSING_FLAGS = ["ana", "ta", "world"];
const MAPPED_FLAGS = {
  ea: "es"
};
function Flag({ code, size, title, greyscale = false, rounded = false }) {
  const { w, h } = FLAG_STYLES[size];
  const mappedCode = useMemo(
    () => isCountryFlagCode(code) ? MAPPED_FLAGS[code] ?? code : UNKNOWN_COUNTRY_CODE,
    [code]
  );
  const [iconUri, setIconUri] = useState(() => {
    if (MISSING_FLAGS.includes(code)) {
      return "";
    }
    return `https://cdn.jsdelivr.net/gh/lipis/flag-icons@main/flags/4x3/${mappedCode}.svg`;
  });
  useEffect(() => {
    if (MISSING_FLAGS.includes(mappedCode)) {
      const importIcon = async () => await __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "./assets/ana.svg": () => import("./ana-ByuO1Lga.js"), "./assets/ta.svg": () => import("./ta-DtrEBuqh.js"), "./assets/world.svg": () => import("./world-B9NzZdqc.js") }), `./assets/${mappedCode}.svg`, 3);
      void importIcon().then((icon) => {
        setIconUri(icon.default);
      });
    }
  }, [mappedCode]);
  return /* @__PURE__ */ jsx(Skeleton, { isLoaded: Boolean(iconUri), children: /* @__PURE__ */ jsx(
    Box,
    {
      filter: greyscale ? "grayscale(100%)" : void 0,
      borderRadius: rounded ? "full" : "sm",
      overflow: "hidden",
      width: rounded ? h : w,
      height: h,
      boxShadow: "inset 0 0 0 1px rgba(37, 48, 60, 0.1)",
      background: `url("${iconUri}")`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      "data-flag": title ?? code
    }
  ) });
}
export {
  Al,
  Anac$1 as Anac,
  At,
  Au,
  Bg,
  Br,
  COUNTRIES,
  Ca,
  Ch,
  Cn,
  Cs,
  De,
  Dk,
  Es,
  Eu,
  Fi,
  Flag,
  Fr,
  Gb,
  Gr,
  Hu,
  Ie,
  In,
  Int,
  It,
  Jp,
  Md,
  Nl,
  No,
  Nz,
  Om,
  Pl,
  Pt,
  Qa,
  Ro,
  RoundedBr,
  RoundedEarth,
  RoundedEu,
  RoundedUs,
  Ru,
  Sa,
  Se,
  Tr,
  UNKNOWN_COUNTRY_CODE,
  Un,
  Us,
  Za,
  isCountryFlagCode
};
//# sourceMappingURL=index.js.map
